import { CommonModule } from '@angular/common';
import { Component, HostListener, Inject } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ENVIRONMENT } from 'environments-lib';
import { IEnvironment } from 'interfaces-lib';

@Component({
  selector: 'app-version',
  imports: [CommonModule, MatTooltipModule],
  templateUrl: './version.component.html',
  styleUrl: './version.component.scss',
})
export class VersionComponent {
  version: string;
  expandVersion = false;

  constructor(@Inject(ENVIRONMENT) protected environment: Partial<IEnvironment>) {
    this.version = environment.version;
  }

  // Keyboard Shortcuts
  // - Use Alt + Shift + V to enlarge version number
  // - Use Alt + Shift + M to open Menu/Hamburger
  @HostListener('document:keydown', ['$event'])
  protected handleKeydownEvent(event: KeyboardEvent) {
    if (event.altKey && event.shiftKey) {
      if (event.code === 'KeyV') {
        this.expandVersion = true;
        setTimeout(() => {
          window.scrollTo(0, document.body.scrollHeight);
        }, 200);
        setTimeout(() => {
          this.expandVersion = false;
        }, 1500);
      }
    }
  }

  copyToClipboard(msg: any): void {
    const listener = (e: ClipboardEvent) => {
      e.clipboardData.setData('text/plain', msg);
      e.preventDefault();
      document.removeEventListener('copy', listener);
    };
    document.addEventListener('copy', listener);
    document.execCommand('copy');
  }
}
